<template>
  <div class="page-wrapper ">
    <Tabs v-model="currentTab">
      <TabPane label="约看" name="ZADKPJ"></TabPane>
      <TabPane label="新签" name="ZRYNEWSIGN"></TabPane>
      <TabPane label="续约" name="ZRYRESIGN"></TabPane>
      <TabPane label="租期" name="ZRYZQ"></TabPane>
    </Tabs>
    <keep-alive>
      <div class="notitle">
        <search-list1 v-if="['ZADKPJ','ZRYNEWSIGN','ZRYRESIGN'].indexOf(currentTab)!==-1"
                      :projectList="projectList"
                      :keyList="keyList"
                      :currentTab="currentTab"
                      :conditionList="conditionList"
                      @exportlist="exportEvaluateList"
                      @getdetail="getEvaluateModuleDetail"
        ></search-list1>
      </div>
    </keep-alive>
    <keep-alive>
      <search-list2 v-if="currentTab==='ZRYZQ'"
                    :projectList="projectList"
                    :keyList="keyList"
                    :conditionList="conditionList"
                    @exportlist="exportEvaluateList"
                    @getdetail="getEvaluateModuleDetail"
      ></search-list2>
    </keep-alive>


  </div>
</template>

<script>
  import SearchList1 from './components/Content1'
  import SearchList2 from './components/Content2'
  import {getListCondition, exportEvaluateList, getEvaluateModuleDetail} from "../../../api/evaluation";
  import {getProjects} from "../../../api/common";
  import {formatDateTime} from "../../../utils/format";

  export default {
    name: "manage",
    created() {
      this.initProject();
      getListCondition().then(res => {
        this.conditionList = res.data
      })


    },
    computed: {
      keyList() {
        if (this.currentTab === 'ZADKPJ') {
          return [{text: '客户电话', value: 'customerPhone'}, {text: '客户姓名', value: 'customerName'}]
        }
        if (this.currentTab === 'ZRYNEWSIGN' || this.currentTab === 'ZRYRESIGN') {
          return [{text: '房间/床位号', value: 'stockNumber'}, {text: '合同号（子合同号）', value: 'contractCode'}, {
            text: '客户名称',
            value: 'customerName'
          }]
        }
        if (this.currentTab === 'ZRYZQ') {
          return [{text: '房间/床位号', value: 'stockNumber'}, {text: '合同号（子合同号）', value: 'contractCode'}, {
            text: '客户名称',
            value: 'customerName'
          }]
        }
        return []
      }
    },
    components: {
      SearchList1,
      SearchList2
    },
    data() {
      return {
        projectList: [],
        conditionList: {},
        currentTab: 'ZADKPJ',
      }
    },
    methods: {
          initProject() {
      getProjects().then(res => {
        this.projectList = res.data;
      });
    },
      getEvaluateModuleDetail(code) {
        const params = {
          businessCode: code,
          evaluateType: this.currentTab
        }
        getEvaluateModuleDetail(params).then(res => {
          if (!res.data) {
            return
          }
          if (this.currentTab === 'ZADKPJ') {
            this.$Modal.info({
              render: (h) => {
                const style = {}


                return h('div', {
                  style: {
                    marginTop: '-20px',
                    lineHeight: 2
                  }

                }, [
                  h('h2', {style: {marginBottom: '10px'}}, '商机详情'),
                  h('h3', {}, res.data.projectName),
                  h('p', {}, [h('span', {style: style}, '客户电话：'), h('span', {}, res.data.userPhone)]),
                  h('p', {}, [h('span', {style: style}, '约看房型：'), h('span', {}, res.data.houseType)]),
                  h('p', {}, [h('span', {style: style}, '创建时间：'), h('span', {}, formatDateTime(res.data.createTime))]),
                  h('p', {}, [h('span', {style: style}, '处理时间：'), h('span', {}, formatDateTime(res.data.handleTime))]),
                  h('p', {}, [h('span', {style: style}, '处理结果：'), h('span', {}, res.data.handleResult)])

                ])
              }

            })

          }
          else {
            this.$Modal.confirm({
              render: (h) => {
                const style = {}
                return h('div', {
                  style: {
                    marginTop: '-20px',
                    lineHeight: 2
                  }

                }, [
                  h('h2', {style: {marginBottom: '10px'}}, '客户详情'),
                  h('h3', {}, res.data.projectName),
                  h('p', {}, [h('span', {style: style}, '房间号/床位号：'), h('span', {}, res.data.stockNumber)]),
                  h('p', {}, [h('span', {style: style}, '合同号：    '), h('span', {}, res.data.contractCode)]),
                  h('p', {}, [h('span', {style: style}, '客户名称：   '), h('span', {}, res.data.userName)]),
                  h('p', {}, [h('span', {style: style}, '电话号：    '), h('span', {}, res.data.userPhone)]),
                  h('p', {}, [h('span', {style: style}, '合同租期：   '), h('span', {}, res.data.rentTime)])

                ])
              }
            })
          }


        }).catch(error => {
        })

      },
      exportEvaluateList(num, params) {
        if (num === 0) {
          this.$Message.info('数据列表为空！')
          return
        }
        if (num > 10000) {
          this.$Message.info('数量超过上限，请重新选择查询条件')
          return
        }
        exportEvaluateList(params).then(res => {
          const fileName = res.headers.filename || 'excel.xls'
          const blob = new Blob([res.data])

          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          // this.btnLoading = false
        }).catch(err => {
        })

      }


    }
  }
</script>

<style scoped>


</style>
